import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseBranchSummaryStudyCategoryProgressCourses,
  ApiResponseAcademySummaryStudyCategoryProgressCourses,
} from '@/api/responses/manage/summaryStudyCategoryProgressCourses'

export namespace SummaryStudyCategoryProgressCoursesApi {
  /**
   * コース別通常学習進捗平均一覧取得API(教室基準での比較)
   *
   * @param branchId 教室ID
   * @param studyCategoryId 教材ID
   * @returns コース別平均一覧
   */
  export async function getSummaryAsBranch(
    branchId: number,
    studyCategoryId: number
  ): Promise<ApiResponseBranchSummaryStudyCategoryProgressCourses> {
    const params = {
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get(`/manage/summaryProgress/branches/${branchId}/courses`, params)
  }

  /**
   * コース別通常学習進捗平均一覧取得API(塾基準での比較)
   *
   * @param academyId 教室ID
   * @param courseId コース
   * @param studyCategoryId 教材ID
   * @returns コース別平均一覧
   */
  export async function getSummaryAsAcademy(
    academyId: number,
    courseId: number,
    studyCategoryId: number
  ): Promise<ApiResponseAcademySummaryStudyCategoryProgressCourses> {
    const params = {
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get(`/manage/summaryProgress/academies/${academyId}/courses/${courseId}`, params)
  }
}
